
// 🔁 Switch automatically based on environment
const API_BASE_URL =
  process.env.NODE_ENV === 'production'
    ? 'https://api.laminance.com/api'
    : 'http://localhost:5000/api';

console.log('🌍 Environment:', process.env.NODE_ENV || 'development');
console.log('🔗 API Base URL:', API_BASE_URL);

class ApiService {
  constructor() {
    this.baseURL = API_BASE_URL;
  }



  async request(endpoint, options = {}) {
    const url = `${this.baseURL}${endpoint}`;
    
    const token = localStorage.getItem("accessToken");
  
    if (process.env.NODE_ENV !== 'production') {
  console.log('🔑 TOKEN CHECK:', token);
}

const config = {
  method: options.method || 'GET',
  credentials: token ? 'include' : 'omit',

  headers: {
    'Content-Type': 'application/json',
    ...(token && { Authorization: `Bearer ${token}` }),
    ...(options.headers || {}),
  },
  ...(options.body && { body: JSON.stringify(options.body) }),
};





    // Convert body object → JSON
  
    try {
      const response = await fetch(url, config);

      let data = null;
      const contentType = response.headers.get('content-type');
      
      if (contentType && contentType.includes('application/json')) {
        try {
          data = await response.json();
        } catch (e) {
          console.warn('Failed to parse JSON:', e);
        }
      } else {
        const text = await response.text();
        console.log('Non-JSON response:', text.substring(0, 200));
        data = { message: text };
      }

      if (!response.ok) {
        const message =
          data?.message ||
          data?.error ||
          `Request failed with status ${response.status}`;

        const error = new Error(message);
        error.status = response.status;
        error.data = data;
        throw error;
      }

      return data;
    } catch (error) {
      console.error('❌ API Error:', {
        endpoint,
        error: error.message,
        status: error.status
      });
      
      // User-friendly error messages
      let userMessage = error.message;
      
      if (error.message.includes('Failed to fetch') || error.message.includes('NetworkError')) {
        userMessage = process.env.NODE_ENV === 'production'
          ? 'Unable to reach server. Please try again later.'
          : 'Cannot connect to server. Make sure backend is running.';
      } else if (error.message.includes('timeout')) {
        userMessage = 'Request timeout. Please try again.';
      }
      
      throw new Error(userMessage);
    }
  }

  /* =========================
     CONTACT FORM (PUBLIC - NO AUTH)
     ========================= */

  async submitContact(contactData) {
    console.log('📝 Submitting contact form');
    return this.request('/contact/submit', {
      method: 'POST',
      body: contactData,
    });
  }

  /* =========================
     CONTACT ADMIN (AUTH NEEDED)
     ========================= */

  async getAllContacts(query = {}) {
    const params = new URLSearchParams(query).toString();
    return this.request(
      params ? `/contact/admin/all?${params}` : '/contact/admin/all'
    );
  }

  async getContactStats() {
    return this.request('/contact/admin/stats');
  }

  async updateContactStatus(id, statusData) {
    return this.request(`/contact/admin/${id}/status`, {
      method: 'PUT',
      body: statusData,
    });
  }

/* =========================
   APPOINTMENTS (AUTH NEEDED)
   ========================= */

  async getAllAppointments() {
    return this.request('/appointments');
  }

  async getUserAppointments() {
    return this.request('/appointments/user/my-appointments');
  }

  async getAppointmentById(id) {
    return this.request(`/appointments/${id}`);
  }

  async getAppointmentsByDate(date) {
    return this.request(`/appointments/date/${date}`);
  }

  async createAppointment(data) {
    return this.request('/appointments', {
      method: 'POST',
      body: data,
    });
  }

  async updateAppointment(id, data) {
    return this.request(`/appointments/${id}`, {
      method: 'PUT',
      body: data,
    });
  }

  async deleteAppointment(id) {
    return this.request(`/appointments/${id}`, {
      method: 'DELETE',
    });
  }

  async sendAppointmentEmail(id) {
    return this.request(`/appointments/${id}/send-email`, {
      method: 'POST',
    });
  }
  /* =========================
     ORDERS (AUTH NEEDED)
     ========================= */

  async createOrder(orderData) {
    return this.request('/orders/create', {
      method: 'POST',
      body: orderData,
    });
  }

  async getAllOrders() {
    return this.request('/orders/all');
  }

  async getUserOrders() {
    return this.request('/orders/my-orders');
  }

  async getOrderById(orderId) {
    return this.request(`/orders/${orderId}`);
  }

  async updateOrder(orderId, data) {
    return this.request(`/orders/${orderId}`, {
      method: 'PUT',
      body: data,
    });
  }

  async updateOrderStatus(orderId, status) {
    return this.request(`/orders/${orderId}/status`, {
      method: 'PUT',
      body: { status },
    });
  }

  async deleteOrder(orderId) {
    return this.request(`/orders/${orderId}`, {
      method: 'DELETE',
    });
  }

  /* =========================
     UTILITY METHODS
     ========================= */

  async testConnection() {
    try {
      const response = await fetch(`${this.baseURL}/test`, {
        method: 'GET',
        headers: { 'Accept': 'application/json' },
      });
      
      if (response.ok) {
        const data = await response.json();
        return { success: true, data };
      }
      return { success: false, status: response.status };
    } catch (error) {
      return { success: false, error: error.message };
    }
  }

  async getHealth() {
    return this.request('/health', { method: 'GET' });
  }
}

export const apiService = new ApiService();
